export default __webpack_public_path__ + "static/media/logoGif.0ca8fc62.gif";